import React from 'react';
import { TouchableWithoutFeedback, View } from 'react-native';

import PropTypes from 'prop-types';

import FrameworkTestKeys from '../../../../FrameworkTestKeys';

import styles from './CustomSubTrayItemView.Styles';

const CustomSubTrayItemView = ({ accessibilityLabel, onPress, children }) => {
  return (
    <TouchableWithoutFeedback
      accessibilityLabel={accessibilityLabel}
      onPress={onPress}
      accessible={false}
      testID={FrameworkTestKeys.customSubTrayItemViewTWF}
    >
      <View style={styles.containerStyle} testID={FrameworkTestKeys.customSubTrayItemView}>
        {children}
      </View>
    </TouchableWithoutFeedback>
  );
};

CustomSubTrayItemView.propTypes = {
  accessibilityLabel: PropTypes.string,
  onPress: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default CustomSubTrayItemView;
